export default {
  postureReport: "Haltungbericht",
  postureData: "Haltungsdaten",
  postureDataContrast: "Kontrast der Haltungsdaten",
  postureRiskContrast: "Kontrast des Haltungsrisikos",
  postureDataTrend: "Trend der Haltungsdaten",
  postureRiskTrend: "Trend des Haltungsrisikos",
  postureLogData: "Haltung Protokolldaten",
  lateralhead: "Laterale Kopfnickung",
  unevenshoulder: "Ungleiche Schultern",
  scoliosis: "Skoliose",
  unevenhip: "Laterale Beckenneigung",
  xleg: "Pernas em X",
  oleg: "Pernas em O",
  roundedshoulder: "Runder Schulter",
  kneehyperextension: "Knieüberstreckung",
  trunkforwardtilt: "Trunk forward tilt",
  trunklateraltilt: "Trunk Lateral Tilt",
  forwardhead: "Kopf nach vorn",
  toTheLeft: "(links)",
  toTheRight: "(rechts)",
  bracketsLeft: "(L)",
  bracketsRight: "(R)",
  bracketsNormal: "(Normal)",
  leg: "Beine",
  legLeft: "Beine (L)",
  legRight: "Beine (R)",
  riskAssessment: "Risikobewertung",
  muscleState: "Muskelzustand",
  muscleStateDesc: "Keine abnormale Muskelbedingung gefunden",
  testTime: "Testzeit",
  hRisk: "H",
  mRisk: "M",
  lRisk: "L",
  item: "Artikel",
  degree: "°",
  percent: "%",
  mm: "mm",
  moireImage: "Moiré-Bild",
  lAbnormalRisk: "L Risiko",
  mAbnormalRisk: "M Risiko",
  hAbnormalRisk: "H Risiko",
  highRisk: "Hochrisiko",
  riskAnalysis: "Risikoanalyse",
  conclusionRecommendation: "Schlussfolgerung und Empfehlung",
  solution: "Lösung",
  movePosition: "Klicken Sie auf den Punkt, um die Position zu bewegen",
  confirmTheClose: "Noch nicht gespeichert, Bestätigen Sie das Schließen?",
  closeInfo: "Noch nicht gespeichert, Bestätigen Sie das Schließen?",
  share: "Teilen",
  front: "Vorderseite",
  side: "Seite",
  back: "Rückseite",
  otherSide: "Andere Seite",
  points: "Punkte",
  angle: "Winkel",
  name: "Name",
  gender: "Geschlecht",
  male: "männlich",
  female: "weiblich",
  age: "Alter",
  year: "Jahre",
  height: "Höhe",
  weight: "Gewicht",
  time: "Zeit",
  patientId: "Patienten-ID",
  save: "Speichern",
  saveModify: "Speichern Modifizieren",
  print: "Drucken",
  cancel: "Abbrechen",
  zoomIn: "Zoomen In",
  zoomOut: "Zoomen Out",
  ok: "OK",
  return: "Zurück",
  empty: "",
  unknown: "unbekannt",
  succeedToCopy: "Erfolgreich kopiert",
  succeedToSave: "Erfolgreich gespeichert",
  headForwardDistance: "Kopf-Vorwärts-Distanz",
  pelvisForwardTilt: "Becken Vorwärtsneigung",
  wristHipDistanceLeft: "Handgelenk-zu-Hüfte-Entfernung (Links)",
  wristHipDistanceRight: "Handgelenk-zu-Hüfte-Entfernung (Rechts)",
  evaluator: "Bewerter",
  reportDate: "Berichtsdatum",
  introduction: "Einführung",
  doctorIntroDefault: "Fachgebiet: Rehabilitationsmedizin, Haltungsbeurteilung und -korrektur | Berufserfahrung: Mehr als 5 Jahre | Fachkenntnisse: Rehabilitation von Sportverletzungen, Haltungskorrektur, Schmerzmanagement",
  recoveryLog: "Erholungsprotokoll",
  returnToReport: "Zurück zum Bericht",
  loading: "Wird geladen...",
  showToolbox: "Werkzeugkasten anzeigen",
  hideToolbox: "Werkzeugkasten ausblenden",
};

